import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../ui/Button';
import { primaryNavigationItems } from '../../../app/routes/navigation';

const BottomNav = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex justify-center bg-transparent pointer-events-none lg:hidden">
      <div className="pointer-events-auto flex w-full max-w-[480px] items-center justify-around border-t border-gray-100 bg-surface px-1 py-3 shadow-lg">
        {primaryNavigationItems.map(({ icon: Icon, label, path }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 transition-colors relative min-w-0 flex-1 py-1 rounded-xl',
                isActive ? 'text-[#39a74b]' : 'text-gray-400 hover:text-gray-600'
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                <span className={cn('text-[10px] font-medium', isActive ? 'text-[#39a74b]' : 'text-gray-400')}>
                  {label}
                </span>
                {isActive && (
                  <span className="absolute -top-1 h-1 w-1 rounded-full bg-[#39a74b]" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
